import { useCallback, useEffect, useRef } from "react";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ActionIcon } from "@mantine/core";
import { Tooltip } from "components/UI/Tooltip";
import { CollapsibleWidthComponent } from "components/UI/TopMenu/CollapsibleComponent";
import { useEditMode } from "hooks/useEditMode";
import { useGenericModals } from "hooks/useGenericModals";
import { useUserTracks } from "hooks/useUserTracks";
import { useUserWaypoints } from "hooks/useUserWaypoints";
import { useTranslation } from "react-i18next";

export const EditIcon = ({ isOpen }: { isOpen: boolean }) => {
  const { selectedTrack } = useUserTracks();
  const { selectedWaypoint } = useUserWaypoints();
  const { openTrackEditModal, openWaypointEditModal } = useGenericModals();
  const { editMode } = useEditMode();
  const { t } = useTranslation();
  const selectedTrackRef = useRef(selectedTrack);
  const selectedWaypointRef = useRef(selectedWaypoint);
  useEffect(() => {
    selectedTrackRef.current = selectedTrack;
  }, [selectedTrack]);
  useEffect(() => {
    selectedWaypointRef.current = selectedWaypoint;
  }, [selectedWaypoint]);

  const handleClick = useCallback(() => {
    if (selectedTrackRef.current) openTrackEditModal(selectedTrackRef.current);
    if (selectedWaypointRef.current)
      openWaypointEditModal(selectedWaypointRef.current);
  }, [openTrackEditModal, openWaypointEditModal]);

  const disabled = !selectedTrack && !selectedWaypoint;

  return (
    <Tooltip
      label={
        editMode === "track"
          ? t("editmode.edit_button_tooltip.track")
          : t("editmode.edit_button_tooltip.waypoint")
      }
    >
      <div>
        <CollapsibleWidthComponent isOpen={isOpen} width={28} height={28}>
          <ActionIcon
            variant="light"
            disabled={disabled}
            onClick={handleClick}
            styles={(theme, _, u) => ({
              root: {
                [u.dark]: {
                  color: disabled ? undefined : theme.colors.violet[2],
                  backgroundColor: disabled ? undefined : theme.colors.dark[6],
                },
              },
            })}
          >
            <FontAwesomeIcon icon={faPenToSquare} />
          </ActionIcon>
        </CollapsibleWidthComponent>
      </div>
    </Tooltip>
  );
};
